import { requestSignInWithPopup } from "../firebase";
import { toast } from "react-hot-toast";

export const handleSignInWithGoogle = () => {
  requestSignInWithPopup()
    .then((res: any) => {
      const photoURL = res?.user?.photoURL;
      const accessToken = res?.user?.accessToken;
      localStorage.setItem("photoURL", photoURL);
      localStorage.setItem("access-token", accessToken);
      localStorage.setItem("isAuthenticated", true as any);
      window.location.reload()
    })
    .catch((err) => {
      console.log(err);
    });
};

export const AUTH_API_HEADERS = {
  headers: {
    Authorization: localStorage.getItem("token"),
  },
};


export const copyContents = (contents: string) => {
  try {
    navigator.clipboard.writeText(contents);
    toast.success("Copied");
  } catch (e) {
    const typeError = e as Error;
    toast.error(typeError.message);
  }
};
